<template>
  <div id="app" :class="[isMobile ? 'mobile' : 'pc']">
    <div class="theme-d components-layout" ref="layout">
      <headerVue :key="'hd' + componentKey" />
      <router-view @refresh="handleRefresh" />
      <footerVue :key="'ft' + componentKey" />
    </div>
  </div>
</template>

<script>
import headerVue from './views/headerD.vue';
import footerVue from './views/footerD.vue';

// D 套三款字体：display / body / numeric
const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Plus+Jakarta+Sans:wght@400;500;600;700&family=Oswald:wght@300;400;500&display=swap';

export default {
  components: { headerVue, footerVue },
  data() {
    return {
      isMobile: false,
      componentKey: 0,
    }
  },
  created() {
    this.loadFonts()
  },
  mounted() {
    this.isMobile = !!this._isMobile()
  },
  methods: {
    // 只有 D 套才拉这三款字体，A/B/C 不受影响
    loadFonts() {
      if (document.getElementById('theme-d-fonts')) return;
      const link = document.createElement('link')
      link.id = 'theme-d-fonts'
      link.rel = 'stylesheet'
      link.href = FONT_HREF
      document.head.appendChild(link)
    },
    _isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    handleRefresh() {
      this.componentKey += 1
    },
  },
}
</script>

<style lang="scss">
@import './assets/css/reset.scss';
@import './assets/css/theme-d.scss';

html.mobile {
  font-size: 13.3333vw;
  background: #0C2E33;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  &.pc {
    min-width: 1200px;
    overflow-x: auto;
  }
}
</style>

<style lang="scss" scoped>
.components-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  ::v-deep .d-shell {
    flex: 1;
  }
}

.mobile .components-layout {
  /* 给底部固定 Tab / 价格条让位 */
  padding-bottom: px2rem(132);
}
</style>
